import { render } from "./physicians.vue?vue&type=template&id=24f027b8"
import script from "./physicians.vue?vue&type=script&lang=js"
export * from "./physicians.vue?vue&type=script&lang=js"

import "./physicians.vue?vue&type=style&index=0&id=24f027b8&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__